import React, {useState, useEffect} from "react";
import {useNavigate, useLocation, Link} from "react-router-dom";
import {normalizeInput, normalizeDate, calculate_age, isvalid_mdy,normalizeUSDate} from '../functions';
import  {refundMembership} from "../../API/APICalls";
import { env } from "process";


export default function MembershipRefund () {

    const navigate = useNavigate();
    const location = useLocation();
    const [inputs, setInputs] = useState({refundOption: '', comments: ''});
    const [selectedOptions, setSelectedOptions] =  useState<any[]>([]);
    
    const [alert, setAlert] = useState('ms-2 alert alert-danger');
    const [message, setMessage] = useState('');
    const [commentRequired, setCommnentRequired] = useState<boolean>(false);
    const [panel, setPanel] = useState("collapse show");
    const [isLoading, setIsLoading] = useState(true);

    const handleChange = ({ target: { name, value } }: { target: { name: string, value: string } }) => {
        if (name == "refundOption")
        {
            setAlert("");
            setMessage("");
        } 

       if (value === "other")
       {
            setCommnentRequired(true);
       } else {
            setCommnentRequired(false);
       }

        setInputs(inputs => ({ ...inputs, [name]: value }));
    }



    // const handleChange2 = (event:any) => {
    //     const value = event.target.value;
    //     const isChecked = event.target.checked;
    //     if (isChecked)
    //     {
    //         setSelectedOptions([ ...selectedOptions, value]);
    //     } else {
    //         setSelectedOptions(selectedOptions.filter((option) => option !== value));
    //     }
        
    // } 

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        
        event.preventDefault();
        setIsLoading(true);


        if (inputs.refundOption === "")
        {
            setAlert('ms-2 alert alert-danger');
            setMessage("Please select atleast one option.");
        } else {

            // pass data to api.
            const response = await refundMembership(location.state.dealId, inputs.refundOption, inputs.comments, location.state.handicap_id);

            setAlert('ms-2 alert alert-success');
            setMessage("Your refund has successfully started its process. Please check your email for confirmation.");

            setPanel("collapse hide");
            setIsLoading(false);
            
        }
       

      
    }


    useEffect(() => {
        
        setAlert("");
        setIsLoading(false);
    }, [commentRequired]);

  

    return (
        <div className="container page_container mb-5 pb-5">
            <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-12 col-xxl-12">
            
            {isLoading ? 
            <div className="loaderWrapper">
              <div className="loader"></div>
            </div>
            : ''}


                <div className={panel} id="collapseExample">
                
                
            
            
            <form onSubmit={handleSubmit}>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-5 pb-3 ">
                    <h3 className="fs-3 text-left pt-3">Please tell us why you're canceling to help us improve our membership?</h3>
                    <span className="text-secondary">Allow up to 20 days for your refund to appear on your statement.</span>
                </div>

                <div className="row pb-4">
               
                    <div className="col-12 pb-3"><span>Select atleast one reason:</span></div>
                    <div className="col-12">
                        <ul className="list-group fs-5">
                            <li className="list-group-item">
                                <input className="form-check-input me-3" type="radio" name="refundOption" value="joininganotherclub" checked={inputs.refundOption === "joininganotherclub"} onChange={handleChange} />
                                Have or will be joining another club
                            </li>
                            <li className="list-group-item">
                                <input className="form-check-input me-3" type="radio" name="refundOption" value="moving" checked={inputs.refundOption === "moving"} onChange={handleChange}/>
                                Have or will be moving
                            </li>
                            <li className="list-group-item">
                                <input className="form-check-input me-3" type="radio" name="refundOption" value="pricetoohigh" checked={inputs.refundOption === "pricetoohigh"}  onChange={handleChange}/>
                                Priced too high
                            </li>
                            <li className="list-group-item">
                                <input className="form-check-input me-3" type="radio" name="refundOption" value="didntknow" checked={inputs.refundOption === "didntknow"} onChange={handleChange}/>
                                Didn't know what I was signing up for
                            </li>
                            <li className="list-group-item">
                                <input className="form-check-input me-3" type="radio" name="refundOption" value="illnessorinjury" checked={inputs.refundOption === "illnessorinjury"} onChange={handleChange}/>
                                Illness or injury
                            </li>
                            <li className="list-group-item">
                                <input className="form-check-input me-3" type="radio" name="refundOption" value="other" checked={inputs.refundOption === "other"} onChange={handleChange}/>
                                Other – Please specify
                            </li>
                        </ul>
                    </div>

                    
                </div>


                <div className="row pb-4">
                <div className="col-12 pb-3"><span>Additional Comments:</span></div>
                        <textarea className="form-control" id="message-text" rows={8} name="comments" onChange={handleChange} required={commentRequired}>

                        </textarea>
                    
                </div>


                <div className={alert} role="alert">
                {message}
                </div>


                <div className="mt-4 col-12 col-sm-12 col-md-12 col-lg-12 col-lg-12 col-xl-12 col-xxl-12">
                            <div className="row">
                            <div className="col-12 col-sm-6 col-md-6 order-1 pt-3">
                                <Link to="/membership/dashboard" state={{"contact_guid": location.state.contact_guid, "handicap_id": location.state.handicap_id}} className="w-100 btn btn-outline-secondary btn-lg rounded-pill px-5 " type="button">
                                    BACK
                                </Link>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6 order-sm-1 order-lg-1 pt-3">
                                <button className="btn btn-primary w-100 btn-lg px-5 rounded-pill" type="submit">
                                    CONTINUE
                                </button>
                            </div>
                        </div>
                        </div>
                </form>
                </div>

                {/* success here*/}

                { panel === "collapse hide" ? 
                    <div className="row col-10 py-5 mx-auto text-center">
                    <div className={alert} role="alert">
                    {message}
                    </div>
                    <div className="fs-5">Thank you!</div>
                    <div className="fs-5">If you have any questions about your refund, please email <a href="mailto:gcsupport@usga.org">gcsupport@usga.org</a>.</div>
                    <div className="row">
                            <div className="col-12 col-sm-10 col-md-10 mx-auto pt-3">
                                <Link to="/membership/dashboard" state={{"contact_guid": location.state.contact_guid, "handicap_id": location.state.handicap_id}} className="w-100 btn btn-outline-primary btn-lg rounded-pill px-5 " type="button">
                                    Manage Memberships
                                </Link>
                            </div>

                    </div>
                </div>
                    
                
                : ''
                }



            </div>
        </div>
)

}
